// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* menu-bar should go over monitors, alerts and tutorials */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

.loader_background_GM3o9 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 490;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--menu-bar-background);
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    text-align: center;
    color: white;
}

.loader_fullscreen_DHYRi {
    /* Break out of the layout using position: fixed to cover the whole screen */
    position: fixed;
    /* Use the fullscreen stage z-index to allow covering full-screen mode */
    z-index: 500;
}

.loader_block-animation_hdGzC {
    width: 125px;
    height: 150px;
    margin: 50px auto 0px;
}

.loader_block-animation_hdGzC img {
    display: block;
    position: relative;
    height: 30%;
    margin-top: -4px;
}

.loader_top-block_ZwqlM {
    animation: loader_top-slide-in_QFW6O 1.5s ease infinite;
}

.loader_middle-block_E0ABO {
    animation: loader_middle-slide-in_d89lE 1.5s ease infinite;
}

.loader_bottom-block_hOYhq {
    animation: loader_bottom-slide-in_XrRBg 1.5s ease infinite;
}

[dir="rtl"] .loader_top-block_ZwqlM {
    animation: loader_top-slide-in-rtl_HQgaR 1.5s ease infinite;
}

[dir="rtl"] .loader_middle-block_E0ABO {
    animation: loader_middle-slide-in-rtl_B0JNm 1.5s ease infinite;
}

[dir="rtl"] .loader_bottom-block_hOYhq {
    animation: loader_bottom-slide-in-rtl_cJFTZ 1.5s ease infinite;
}

@keyframes loader_top-slide-in_QFW6O {
  0% {
    transform: translateY(50px);
    opacity: 0;
  }

  33% {
    transform: translateY(0px);
    opacity: 1;
  }
}

@keyframes loader_middle-slide-in_d89lE {
  0% {
    transform: translateY(50px);
    opacity: 0;
  }

  33% {
    transform: translateY(50px);
    opacity: 0;
  }

  66% {
    transform: translateY(0px);
    opacity: 1;
  }
}

@keyframes loader_bottom-slide-in_XrRBg {
  0% {
    transform: translateY(50px);
    opacity: 0;
  }

  66% {
    transform: translateY(50px);
    opacity: 0;
  }

  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}

@keyframes loader_top-slide-in-rtl_HQgaR {
  0% {
    transform: translateY(50px) scaleX(-1);
    opacity: 0;
  }

  33% {
    transform: translateY(0px) scaleX(-1);
    opacity: 1;
  }
  100% {
    transform: translateY(0px) scaleX(-1);
    opacity: 1;
  }
}

@keyframes loader_middle-slide-in-rtl_B0JNm {
  0% {
    transform: translateY(50px) scaleX(-1);
    opacity: 0;
  }

  33% {
    transform: translateY(50px) scaleX(-1);
    opacity: 0;
  }

  66% {
    transform: translateY(0px) scaleX(-1);
    opacity: 1;
  }
  100% {
    transform: translateY(0px) scaleX(-1);
    opacity: 1;
  }
}

@keyframes loader_bottom-slide-in-rtl_cJFTZ {
  0% {
    transform: translateY(50px) scaleX(-1);
    opacity: 0;
  }

  66% {
    transform: translateY(50px) scaleX(-1);
    opacity: 0;
  }

  100% {
    transform: translateY(0px) scaleX(-1);
    opacity: 1;
  }
}

.loader_title_SkTss {
    font-size: 2rem;
    font-weight: bold;
    margin: 0.75rem 0;
}

.loader_message_UX9Q3 {
    height: 20px;
    margin: 5px 0;
}

.loader_bar-outer_ya7DU {
    width: 250px;
    height: 8px;
    border-radius: 8px;
    background-color: var(--ui-white-transparent-default);
    overflow: hidden;
    position: relative;
    margin: auto;
}

.loader_bar-inner_oGyhe {
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 100%;
    background-color: var(--ui-white-default);
}

.loader_message-container-outer_Mh4ro {
    height: 30px;
    overflow: hidden;
}

.loader_message-container-inner_nEbHY {
    transition: transform 0.5s;
}
`, "",{"version":3,"sources":["webpack://./src/components/loader/loader.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,2DAA2D;;AAE3D,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,4CAA4C;IAC5C,2DAA2D;IAC3D,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,4EAA4E;IAC5E,eAAe;IACf,wEAAwE;IACxE,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,uDAA0C;AAC9C;;AAEA;IACI,0DAA6C;AACjD;;AAEA;IACI,0DAA6C;AACjD;;AAEA;IACI,2DAA8C;AAClD;;AAEA;IACI,8DAAiD;AACrD;;AAEA;IACI,8DAAiD;AACrD;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,0BAA0B;IAC1B,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,0BAA0B;IAC1B,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,0BAA0B;IAC1B,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sCAAsC;IACtC,UAAU;EACZ;;EAEA;IACE,qCAAqC;IACrC,UAAU;EACZ;EACA;IACE,qCAAqC;IACrC,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sCAAsC;IACtC,UAAU;EACZ;;EAEA;IACE,sCAAsC;IACtC,UAAU;EACZ;;EAEA;IACE,qCAAqC;IACrC,UAAU;EACZ;EACA;IACE,qCAAqC;IACrC,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sCAAsC;IACtC,UAAU;EACZ;;EAEA;IACE,sCAAsC;IACtC,UAAU;EACZ;;EAEA;IACE,qCAAqC;IACrC,UAAU;EACZ;AACF;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,qDAAqD;IACrD,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* menu-bar should go over monitors, alerts and tutorials */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n.background {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 490;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: var(--menu-bar-background);\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    text-align: center;\n    color: white;\n}\n\n.fullscreen {\n    /* Break out of the layout using position: fixed to cover the whole screen */\n    position: fixed;\n    /* Use the fullscreen stage z-index to allow covering full-screen mode */\n    z-index: 500;\n}\n\n.block-animation {\n    width: 125px;\n    height: 150px;\n    margin: 50px auto 0px;\n}\n\n.block-animation img {\n    display: block;\n    position: relative;\n    height: 30%;\n    margin-top: -4px;\n}\n\n.top-block {\n    animation: top-slide-in 1.5s ease infinite;\n}\n\n.middle-block {\n    animation: middle-slide-in 1.5s ease infinite;\n}\n\n.bottom-block {\n    animation: bottom-slide-in 1.5s ease infinite;\n}\n\n[dir=\"rtl\"] .top-block {\n    animation: top-slide-in-rtl 1.5s ease infinite;\n}\n\n[dir=\"rtl\"] .middle-block {\n    animation: middle-slide-in-rtl 1.5s ease infinite;\n}\n\n[dir=\"rtl\"] .bottom-block {\n    animation: bottom-slide-in-rtl 1.5s ease infinite;\n}\n\n@keyframes top-slide-in {\n  0% {\n    transform: translateY(50px);\n    opacity: 0;\n  }\n\n  33% {\n    transform: translateY(0px);\n    opacity: 1;\n  }\n}\n\n@keyframes middle-slide-in {\n  0% {\n    transform: translateY(50px);\n    opacity: 0;\n  }\n\n  33% {\n    transform: translateY(50px);\n    opacity: 0;\n  }\n\n  66% {\n    transform: translateY(0px);\n    opacity: 1;\n  }\n}\n\n@keyframes bottom-slide-in {\n  0% {\n    transform: translateY(50px);\n    opacity: 0;\n  }\n\n  66% {\n    transform: translateY(50px);\n    opacity: 0;\n  }\n\n  100% {\n    transform: translateY(0px);\n    opacity: 1;\n  }\n}\n\n@keyframes top-slide-in-rtl {\n  0% {\n    transform: translateY(50px) scaleX(-1);\n    opacity: 0;\n  }\n\n  33% {\n    transform: translateY(0px) scaleX(-1);\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(0px) scaleX(-1);\n    opacity: 1;\n  }\n}\n\n@keyframes middle-slide-in-rtl {\n  0% {\n    transform: translateY(50px) scaleX(-1);\n    opacity: 0;\n  }\n\n  33% {\n    transform: translateY(50px) scaleX(-1);\n    opacity: 0;\n  }\n\n  66% {\n    transform: translateY(0px) scaleX(-1);\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(0px) scaleX(-1);\n    opacity: 1;\n  }\n}\n\n@keyframes bottom-slide-in-rtl {\n  0% {\n    transform: translateY(50px) scaleX(-1);\n    opacity: 0;\n  }\n\n  66% {\n    transform: translateY(50px) scaleX(-1);\n    opacity: 0;\n  }\n\n  100% {\n    transform: translateY(0px) scaleX(-1);\n    opacity: 1;\n  }\n}\n\n.title {\n    font-size: 2rem;\n    font-weight: bold;\n    margin: 0.75rem 0;\n}\n\n.message {\n    height: 20px;\n    margin: 5px 0;\n}\n\n.bar-outer {\n    width: 250px;\n    height: 8px;\n    border-radius: 8px;\n    background-color: var(--ui-white-transparent-default);\n    overflow: hidden;\n    position: relative;\n    margin: auto;\n}\n\n.bar-inner {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 0;\n    height: 100%;\n    background-color: var(--ui-white-default);\n}\n\n.message-container-outer {\n    height: 30px;\n    overflow: hidden;\n}\n\n.message-container-inner {\n    transition: transform 0.5s;\n}\n"],"sourceRoot":""}]);
// Exports
export var background = `loader_background_GM3o9`;
export var fullscreen = `loader_fullscreen_DHYRi`;
var _1 = `loader_block-animation_hdGzC`;
export { _1 as "block-animation" };
export var blockAnimation = `loader_block-animation_hdGzC`;
var _2 = `loader_top-block_ZwqlM`;
export { _2 as "top-block" };
export var topBlock = `loader_top-block_ZwqlM`;
var _3 = `loader_top-slide-in_QFW6O`;
export { _3 as "top-slide-in" };
export var topSlideIn = `loader_top-slide-in_QFW6O`;
var _4 = `loader_middle-block_E0ABO`;
export { _4 as "middle-block" };
export var middleBlock = `loader_middle-block_E0ABO`;
var _5 = `loader_middle-slide-in_d89lE`;
export { _5 as "middle-slide-in" };
export var middleSlideIn = `loader_middle-slide-in_d89lE`;
var _6 = `loader_bottom-block_hOYhq`;
export { _6 as "bottom-block" };
export var bottomBlock = `loader_bottom-block_hOYhq`;
var _7 = `loader_bottom-slide-in_XrRBg`;
export { _7 as "bottom-slide-in" };
export var bottomSlideIn = `loader_bottom-slide-in_XrRBg`;
var _8 = `loader_top-slide-in-rtl_HQgaR`;
export { _8 as "top-slide-in-rtl" };
export var topSlideInRtl = `loader_top-slide-in-rtl_HQgaR`;
var _9 = `loader_middle-slide-in-rtl_B0JNm`;
export { _9 as "middle-slide-in-rtl" };
export var middleSlideInRtl = `loader_middle-slide-in-rtl_B0JNm`;
var _a = `loader_bottom-slide-in-rtl_cJFTZ`;
export { _a as "bottom-slide-in-rtl" };
export var bottomSlideInRtl = `loader_bottom-slide-in-rtl_cJFTZ`;
export var title = `loader_title_SkTss`;
export var message = `loader_message_UX9Q3`;
var _b = `loader_bar-outer_ya7DU`;
export { _b as "bar-outer" };
export var barOuter = `loader_bar-outer_ya7DU`;
var _c = `loader_bar-inner_oGyhe`;
export { _c as "bar-inner" };
export var barInner = `loader_bar-inner_oGyhe`;
var _d = `loader_message-container-outer_Mh4ro`;
export { _d as "message-container-outer" };
export var messageContainerOuter = `loader_message-container-outer_Mh4ro`;
var _e = `loader_message-container-inner_nEbHY`;
export { _e as "message-container-inner" };
export var messageContainerInner = `loader_message-container-inner_nEbHY`;
export default ___CSS_LOADER_EXPORT___;
